import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface InlineCodeProps {
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

/** Inline element for displaying program code */
export default function InlineCode({ sx, children }: InlineCodeProps): React.ReactNode {
  return (
    <Box
      component='code'
      sx={{
        backgroundColor: (theme) => theme.palette.secondary.light,
        color: (theme) =>
          theme.palette.mode === "dark" ? theme.palette.text.main : theme.palette.secondary.main,
        boxShadow: (th) => th.shadows[1],
        padding: "2px 6px",
        borderRadius: "2px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
